import styled, { css } from 'styled-components';
import { VisuallyHidden } from '../utils.styles';
import BigImage from '../BigImage/BigImage';
import { device } from '../breakpoints';
import Showcase from '../Showcase/Showcase';
import ContentItemCarousel from '../ContentItemCarousel/ContentItemCarousel';

export const StyledDisplayWindow = styled.section`
    position: relative;
    margin-bottom: 40px;
`;

export const HiddenHeading = styled.h2`
    ${VisuallyHidden}

    @media ${device.GteSmall} {
        display: none;
    }
`;

export const Hero = styled(BigImage)`
    display: none;

    @media ${device.GteSmall} {
        display: block;
    }
`;

export const DisplayWindowShowCase = styled(Showcase)`
    ${(props) =>
        props.isCampaign &&
        css`
            article:first-of-type {
                display: none;
            }
        `}
    @media ${device.GteSmall} {
        article:first-of-type {
            display: none;
        }
    }

    @media ${device.GteMedium} {
        display: none;
    }
`;

export const DisplayWindowCarousel = styled(ContentItemCarousel)`
    display: none;

    @media ${device.GteMedium} {
        display: block;
    }
`;
